module.exports = __webpack_public_path__ + "static/media/km.7e036a43.svg";